import { render, staticRenderFns } from "./Prices.vue?vue&type=template&id=0cc8a81e&"
import script from "./Prices.vue?vue&type=script&lang=js&"
export * from "./Prices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports